import { defineWidgetCore } from "../../widgetDefinition";
import type { TextComponentSpec } from "../../Processing/types";
import { renderText } from "../../PDF/renderers/textPdfRenderer";
import { resolveTemplate } from "../../Utils/resolveTemplate";

export const textCore = defineWidgetCore<TextComponentSpec>({
  process(spec) {
    return { type: "text", spec };
  },
  pdf: {
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "text") return null;
      const rawContent = processed.spec.display.content ?? "";
      // The content is HTML, so every substituted value is escaped before it lands in it.
      const { resolved } = resolveTemplate(rawContent, slicerValues, { escapeHtml: true });
      return { type: "text", content: resolved };
    },
    render({ snapshot, rect, scale }) {
      if (snapshot.type !== "text") return null;
      return renderText(snapshot, rect, scale);
    },
  },
});
